module.exports = __webpack_public_path__ + "img/scan.54f50a74.png";